export default __webpack_public_path__ + "static/media/house-nurse.42b127a9.svg";